export const surveysConfig = {
  currentYear: 2026,
  currentYearSurveyId: 3,
  previousYear: 2025,
  previousYearSurveyId: 2
};
